module.exports = __webpack_public_path__ + "static/img/bg.7fee202d.png";